import { IStudyChild } from '@core/state/entities/entity';
import { schema } from 'normalizr';
import { OutcomeDataKey } from '@core/state/entities/entity-name-map';

export interface ITimePoint {
  time?: number;
  average?: number | null;
  error?: number | null;
}

export interface IGraphInfo {
  graphId: string;
  scaleFactor: number;
}

export interface IOutcomeData extends IStudyChild {
  stageId: string;
  outcomeId: string;
  cohortId: string;
  experimentId: string;
  investigatorId: string;
  projectId: string;
  reconciled: boolean;
  greaterIsWorse: boolean;
  units: string;
  averageType: string;
  errorType: string;
  timePoints: ITimePoint[];
  /**
   * `number | null`, not `number`: the wire DTO (`OutcomeDataDto`,
   * api-client.generated.ts) declares this a non-nullable `number`, but a
   * retained-blank cohort animal-count annotation genuinely resolves to
   * `null` up to this point in the AF2 pipeline (see
   * `annotation-form-outcome-topology.ts`'s `derivedCount`). The wire cannot
   * carry `null` (verified: Newtonsoft throws deserializing it into the API's
   * non-nullable `int`), so `null` reaching the actual wire boundary
   * (`toOutcomeDataDto`, annotation-form-persistence.ts) throws a clear,
   * specific error there rather than being silently defaulted away.
   */
  numberOfAnimals: number | null;
  graphId: string | null;
}

export type OutcomeDataEntityKeys = OutcomeDataKey;
export const outcomeDataSchema = new schema.Entity('outcomeData');
